export default __webpack_public_path__ + "static/media/ossscreen5.6761b7cc.png";